import amiriImg from "src/assets/images/projects/amiri.png";
import dashboardImg from "src/assets/images/projects/dashboard.png";
import musicPlayerImg from "src/assets/images/projects/music-player.png";
import ninjaMilImg from "src/assets/images/projects/ninjamail.png";
import pinterestImg from "src/assets/images/projects/pinterest.png";
import ticTacToeImg from "src/assets/images/projects/tictactoe.png";
import todoImg from "src/assets/images/projects/todo.png";
import weatherAppImg from "src/assets/images/projects/weather-app.png";
import game2048Img from "src/assets/images/projects/2048Game.png";
import acmeImg from "src/assets/images/projects/acme.png";
import BootstrapTemplateImg from "src/assets/images/projects/BootstrapTemplate.png";
import circleCubeImg from "src/assets/images/projects/circleCube.png";
import customNavbarImg from "src/assets/images/projects/customNavbar.png";
import dashboardAdminImg from "src/assets/images/projects/dashboard-admin.png";
import earthThreeJsImg from "src/assets/images/projects/earthThreeJs.png";
import formImg from "src/assets/images/projects/form.png";
import glowHoverImg from "src/assets/images/projects/glowHover.png";
import googleSimulationImg from "src/assets/images/projects/google-simulation.png";
import imageBlurImg from "src/assets/images/projects/imageBlur.png";
import imageDotImg from "src/assets/images/projects/imageDot.png";
import jsDocumentationImg from "src/assets/images/projects/jsdocumentation.png";
import kasukaImg from "src/assets/images/projects/kasuka.png";
import keyboardTesterImg from "src/assets/images/projects/keyboard-tester.png";
import landingPageImg from "src/assets/images/projects/landingpage.png";
import lineHoverImg from "src/assets/images/projects/lineHover.png";
import MoradiTemplateImg from "src/assets/images/projects/Moradi Template.png";
import myTunesImg from "src/assets/images/projects/mytunes.png";
import myWebImg from "src/assets/images/projects/myweb.png";
import parallaxImg from "src/assets/images/projects/parallax.png";
import pingPongGameImg from "src/assets/images/projects/pingPongGame.png";
import restaurantImg from "src/assets/images/projects/restaurant.png";
import reverseHoverImg from "src/assets/images/projects/reverseHover.png";
import scrollSnapProjectImg from "src/assets/images/projects/scrollSnapProject.png";
import shapelyTemplateImg from "src/assets/images/projects/shapelyTemplate.png";
import styleConferenceImg from "src/assets/images/projects/styleconference.png";
import webComImg from "src/assets/images/projects/WEB.com.png";
import workboxNoteAppImg from "src/assets/images/projects/workboxNoteApp.png";

const projectsData = [
    {
        img: amiriImg,
        link: 'https://helya-moradi.github.io/AMIRI/',
        description: 'Pure JS'
    },
    {
        img: dashboardImg,
        link: 'https://helya-moradi.github.io/Figma-Dashboard/',
        description: 'Pure JS'
    },
    {
        img: musicPlayerImg,
        link: 'https://helya-moradi.github.io/Music-Player/',
        description: 'Pure JS'
    },
    {
        img: ninjaMilImg,
        link: 'https://helya-moradi.github.io/NinjaMail/',
        description: 'Pure JS'
    },
    {
        img: pinterestImg,
        link: 'https://helya-moradi.github.io/Pinterest-Simulation/',
        description: 'Pure JS'
    },
    {
        img: ticTacToeImg,
        link: 'https://helya-moradi.github.io/Tic-Tac-Toe/',
        description: 'Pure JS'
    },
    {
        img: todoImg,
        link: 'https://helya-moradi.github.io/Todo-List/',
        description: 'Pure JS'
    },
    {
        img: weatherAppImg,
        link: 'https://helya-moradi.github.io/Weather-App/',
        description: 'Pure JS'
    },
    {
        img: game2048Img,
        link: 'https://helya-moradi.github.io/2048Game/',
        description: 'Typescript'
    },
    {
        img: acmeImg,
        link: 'https://helya-moradi.github.io/AcmePhotography/',
        description: 'Pure JS'
    },
    {
        img: BootstrapTemplateImg,
        link: 'https://helya-moradi.github.io/Bootstrap-Template/',
        description: 'Bootstrap'
    },
    {
        img: circleCubeImg,
        link: 'https://helya-moradi.github.io/circleCube/',
        description: 'Three JS'
    },
    {
        img: customNavbarImg,
        link: 'https://helya-moradi.github.io/customNavbar/',
        description: 'Pure JS'
    },
    {
        img: dashboardAdminImg,
        link: 'https://helya-moradi.github.io/dashboard-admin/',
        description: 'React JS'
    },
    {
        img: earthThreeJsImg,
        link: 'https://helya-moradi.github.io/earthThreeJs/',
        description: 'Three JS'
    },
    {
        img: formImg,
        link: 'https://helya-moradi.github.io/freeCodeCamp-Form/',
        description: 'Pure JS'
    },
    {
        img: glowHoverImg,
        link: 'https://helya-moradi.github.io/glowHover/',
        description: 'Pure JS'
    },
    {
        img: googleSimulationImg,
        link: 'https://helya-moradi.github.io/Google-Simulation/',
        description: 'Pure JS'
    },
    {
        img: imageBlurImg,
        link: 'https://helya-moradi.github.io/imageBlur/',
        description: 'Canvas'
    },
    {
        img: imageDotImg,
        link: 'https://helya-moradi.github.io/imageDot/',
        description: 'Canvas'
    },
    {
        img: jsDocumentationImg,
        link: 'https://helya-moradi.github.io/TechnicalDocumentation/',
        description: 'Pure JS'
    },
    {
        img: kasukaImg,
        link: 'https://helya-moradi.github.io/kasuka-template/',
        description: 'React JS'
    },
    {
        img: keyboardTesterImg,
        link: 'https://helya-moradi.github.io/Keyboard-Tester/',
        description: 'Pure JS'
    },
    {
        img: landingPageImg,
        link: 'https://helya-moradi.github.io/Landing-Page/',
        description: 'Pure JS'
    },
    {
        img: lineHoverImg,
        link: 'https://helya-moradi.github.io/lineHover/',
        description: 'Pure JS'
    },
    {
        img: MoradiTemplateImg,
        link: 'https://helya-moradi.github.io/Moradi-Template/',
        description: 'Bootstrap'
    },
    {
        img: myTunesImg,
        link: 'https://helya-moradi.github.io/myTunes/',
        description: 'Pure JS'
    },
    {
        img: myWebImg,
        link: 'https://helya-moradi.github.io/CSS_Grid_Site/',
        description: 'Pure JS'
    },
    {
        img: parallaxImg,
        link: 'https://helya-moradi.github.io/Parallax/',
        description: 'Pure JS'
    },
    {
        img: pingPongGameImg,
        link: 'https://github.com/Helya-Moradi/pingPongGame/',
        description: 'Websocket'
    },
    {
        img: restaurantImg,
        link: 'https://helya-moradi.github.io/Sass-Project/',
        description: 'Pure JS'
    },
    {
        img: reverseHoverImg,
        link: 'https://helya-moradi.github.io/reverseHover/',
        description: 'Pure JS'
    },
    {
        img: scrollSnapProjectImg,
        link: 'https://helya-moradi.github.io/scrollSnapProject/',
        description: 'Pure JS'
    },
    {
        img: shapelyTemplateImg,
        link: 'https://helya-moradi.github.io/ShapelyTemplate/',
        description: 'React JS'
    },
    {
        img: styleConferenceImg,
        link: 'https://helya-moradi.github.io/Styles_Conference/',
        description: 'Pure JS'
    },
    {
        img: webComImg,
        link: 'https://helya-moradi.github.io/WEB.com/',
        description: 'Bootstrap'
    },
    {
        img: workboxNoteAppImg,
        link: 'https://helya-moradi.github.io/workboxNoteApp/',
        description: 'PWA'
    }
]

export default projectsData;